import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import { createStore } from 'vuex-extensions'

Vue.use(Vuex)

export default createStore(Vuex.Store, {
  modules,
  strict: process.env.NODE_ENV === 'development',
  state: {
    layout: 'simple-layout'
  },
  mutations: {
    SET_LAYOUT (state, payload) {
      state.layout = payload
    }
  },
  getters: {
    layout (state) {
      return state.layout
    }
  }
})
